<div fxLayout="row wrap" fxFlex="100">
  <div *ngIf="showHeights" fxLayout="row wrap" class="heightsAgenda" fxFlex="100">

    <mat-form-field appearance="outline" fxFlex="20" fxFlex.sm="100" fxFlex.xs="100">
      <mat-label>Día de inicio de la semana</mat-label>
      <mat-select
        [(ngModel)]="weekStartsOn"
        (selectionChange)="onWeekStartsOnChange($event.value)">
        <mat-option *ngFor="let day of daysOfWeek" [value]="day.value">
          {{ day.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="20" fxFlex.sm="100" fxFlex.xs="100">
      <mat-label>Hora de inicio del día</mat-label>
      <input
        #filterInput
        placeholder="Introduce la hora de inicio del día"
        matInput
        type="number"
        [(ngModel)]="dayStartHour"
        (ngModelChange)="onDayStartHourChange($event)"
        min="0"
        max="23"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="20" fxFlex.sm="100" fxFlex.xs="100">
      <mat-label>Hora de fin del día</mat-label>
      <input
        #filterInput
        placeholder="Introduce la hora de fin del día"
        matInput
        type="number"
        [(ngModel)]="dayEndHour"
        (ngModelChange)="onDayEndHourChange($event)"
        min="0"
        max="23"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="20" fxFlex.sm="100" fxFlex.xs="100">
      <mat-label>Tamaño de las horas</mat-label>
      <input
        #filterInput
        placeholder="Introduce el tamaño de las horas"
        matInput
        type="number"
        [(ngModel)]="hourSegmentHeight"
        (ngModelChange)="onHourSegmentHeightChange($event)"
        min="70"
      />
    </mat-form-field>
    
    <mat-form-field appearance="outline" fxFlex="20" fxFlex.sm="100" fxFlex.xs="100">
      <mat-label>Divisiones de las horas</mat-label>
      <input
        #filterInput
        placeholder="Introduce las divisiones de las horas"
        matInput
        type="number"
        [(ngModel)]="hourSegments"
        (ngModelChange)="onHourSegmentsChange($event)"
        min="1"
      />
    </mat-form-field>
    <span class="badge-form-change second-bar-tools icons-header-custom close-heights-agenda">
      <button class="btn btnjan eseee" (click)="this.showHeights = !this.showHeights" matTooltip="Finalizar editar tamaños de la agenda"><i class="material-icons">close</i></button>
    </span>
  </div>
  <div class="row top-home" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" class="container" fxLayout.xs="row wrap" fxLayoutAlign.xs="start center">
      <div class="col-md-4 theselector">
          <div class="btn-group" style="float: left">
          <div class="btn btn-primary" (click)="this.view = CalendarView.Month; this.saveFilter();" [class.active]="view === CalendarView.Month">
              <i class="material-icons">calendar_view_month</i> Mes
          </div>
          <div class="btn btn-primary" (click)="this.view = CalendarView.Week; this.saveFilter();" [class.active]="view === CalendarView.Week">
              <i class="material-icons">calendar_view_week</i> Semana
          </div>
          
          <div class="btn btn-primary" (click)="this.view = CalendarView.Day; this.saveFilter();" [class.active]="view === CalendarView.Day">
              <i class="material-icons">calendar_view_day</i> Día
          </div>
        </div>
      </div>
  
      <div class="col-md-4 text-center align-text-middle thedate">
          <div class="arrows text-right" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()"><i class="material-icons">arrow_back</i></div>
          <mat-form-field appearance="none" class="matFormFieldForDatePicker">
              <input style="display: none;" matInput [matDatepicker]="datepicker" [(ngModel)]="viewDate">
              <button class="datepicker" (click)="datepicker.open()">{{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}<!--<mat-icon>date_range</mat-icon>--></button>
              <mat-datepicker #datepicker startView="year" [startAt]="viewDate" ></mat-datepicker>
          </mat-form-field>
          <div class="arrows text-left" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()"><i class="material-icons">arrow_forward</i></div>
      </div>

      <div class="col-md-4 thebuttons" fxLayout="row" fxLayoutAlign="end center">
        <span class="badge-form-change second-bar-tools icons-header-custom">
          <button class="btn btnjan eseee" (click)="goToToday()" matTooltip="Hoy">
            <i class="material-icons">today</i>
          </button>
        </span>
          <span *ngIf="!showHeights" class="badge-form-change second-bar-tools icons-header-custom">
            <button class="btn btnjan eseee" (click)="this.showHeights = !this.showHeights" matTooltip="Editar tamaños de la agenda"><i class="material-icons">aspect_ratio</i></button>
          </span>
          <span *ngIf="showHeights" class="badge-form-change second-bar-tools icons-header-custom">
            <button class="btn btnjan eseee" (click)="this.showHeights = !this.showHeights" matTooltip="Finalizar editar tamaños de la agenda"><i class="material-icons">close</i></button>
          </span>
          <span *ngIf="eventsWithNoDate.length > 0" class="badge-form-change second-bar-tools icons-header-custom">
            <button class="btn btnjan eseee" (click)="showNoDate = !showNoDate" matTooltip="Sin fecha" matBadge="{{ eventsWithNoDate.length }}"><i class="material-icons">event_busy</i></button>
          </span>
      </div>
  </div>
    
  <div style="display: flex; flex-direction: row; width: 100%; position: relative; margin-bottom: 10px;">
    <div #calendarContainer style="padding: 0 10px;" [ngSwitch]="view" *ngIf="loaded" fxFlex="100">
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="customEvents"
        [refresh]="refresh"
        [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="dayClicked($event.day)"
        (eventClicked)="handleEvent('Clicked', $event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [cellTemplate]="customCellTemplate"
        (beforeViewRender)="beforeMonthViewRender($event)"
        [tooltipTemplate]="customEventTooltip"
        [tooltipAppendToBody]="true">
      </mwl-calendar-month-view>
      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="customEvents"
        [refresh]="refresh"
        (eventClicked)="handleEvent('Clicked', $event)"
        (hourSegmentClicked)="handleEvent('HourClicked', $event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [dayStartHour]="dayStartHour"
        [dayEndHour]="dayEndHour"
        [hourSegmentHeight]="this.hourSegmentHeight"
        [hourSegments]="this.hourSegments"
        (beforeViewRender)="beforeMonthViewRenderWeek($event)"
        [tooltipTemplate]="customEventTooltip"
        [tooltipAppendToBody]="true">
      </mwl-calendar-week-view>
      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="customEvents"
        [refresh]="refresh"
        (eventClicked)="handleEvent('Clicked', $event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        [locale]="locale"
        (hourSegmentClicked)="handleEvent('HourClicked', $event)"
        [dayStartHour]="dayStartHour"
        [dayEndHour]="dayEndHour"
        [hourSegmentHeight]="this.hourSegmentHeight"
        [hourSegments]="this.hourSegments"
        (beforeViewRender)="beforeMonthViewRenderDay($event)"
        [tooltipTemplate]="customEventTooltip"
        [tooltipAppendToBody]="true">
      </mwl-calendar-day-view>
    </div>

    <div fxFlex="25" *ngIf="showNoDate" class="events-without-date">
      <h4>Sin fecha</h4>
      <mat-action-list role="list" *ngIf="eventsWithNoDate.length > 0; else noNoDate" [ngStyle]="{ 'max-height.px': calendarHeight - 40, 'overflow-y': 'auto' }">
        <button mat-list-item
                *ngFor="let ev of eventsWithNoDate"
                (mouseenter)="showTooltip($event, ev)"
                (mouseleave)="closeTooltip()"
                (click)="handleEvent('Clicked', ev)">
          {{ ev[labelTittle] || 'Sin título' }}
        </button>
      </mat-action-list>
      <ng-template #noNoDate>
        <p>No hay eventos sin fecha.</p>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #customEventTooltip let-event="event">
  <div class="custom-tooltip" *ngIf="event.dataLoaded" fxLayout="row wrap">
    <div fxFlex="100" *ngFor="let field of event.dataLoaded">
      <b>
        <span [ngStyle]="field['style']" [ngClass]="{'column-only-icon': (field['icon'] && (!field['label'] || field['label'] == null))}">
          <button mat-button style="width: auto;" *ngIf="field['icon']">
            <i class="material-icons" [ngStyle]="{'width': (field['label'] && field['label'] !== null && field['label'] !== '' ? 'auto' : '100%')}"> {{ field['icon'] }} </i>
          </button>
          <span *ngIf="field['label']" [innerHTML]="field['label'] | safeHtml"></span>
        </span>
      </b>
      <ng-container *ngIf="field['type'] == 'image'; else notImage">
        <img class="{{ field['class_custom'] }}" [ngStyle]="field['style']" [src]="field['value']" (error)="field['value'] = this.genericService.defaultNoImage;"/>
      </ng-container>
      <ng-template #notImage>
        <ng-container *ngIf="genericService.checkArray(field['value'])">
          <span>{{ getJoinedValues(field['value']) }}</span>
        </ng-container>
        <ng-container *ngIf="!genericService.checkArray(field['value'])">
          <ng-container *ngIf="field['value'] == 'isbooleantrue'">
            <span><span class="material-icons checked-generic">check_circle</span></span>
          </ng-container>
          <ng-container *ngIf="field['value'] == 'isbooleanfalse'">
            <span><span class="material-icons denied-generic">cancel</span></span>
          </ng-container>
          <ng-container *ngIf="field['value'] != 'isbooleantrue' && field['value'] != 'isbooleanfalse'">
            <span *ngIf="field['value']" class="text-column" style="position: relative;">
              <span [innerHTML]="field['value'] | safeHtml"></span>
            </span>
          </ng-container>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <span *ngIf="loadDataField(event)"></span>
</ng-template>